<template>
  <v-card class="brand-card" :ripple="{ class: 'white--text' }"
          :to="$route.name != PAGE_IDS.BRAND_DETAILS ? {name:PAGE_IDS.BRAND_DETAILS, params: {brand_id:brand.id}}: undefined"
  >
    <v-list-item>
      <v-list-item-avatar class="avatar small">
        <SpotS3Image :image-path="brand.image"></SpotS3Image>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{brand.name}}</v-list-item-title>
        <v-list-item-subtitle> {{manager_info}}</v-list-item-subtitle>
      </v-list-item-content>
      <v-expand-x-transition>
        <div v-if="toggleActions"
             class=" transition-fast-in-fast-out white v-card--reveal primary--text"
             style="height: 100%;">
          <div class="action-btns">
            <v-btn :loading="loadingState" large text
                   color="primary"
                   :to="{name:PAGE_IDS.BRAND_EDIT, params:{brand_id:brand.id}}">
              <v-icon>edit</v-icon>
              Edit
            </v-btn>
            <v-btn :loading="loadingState" large text color="error"
                   @click.native.prevent="deleteBrand">
              <v-icon>delete</v-icon>
              Delete
            </v-btn>
          </div>
        </div>
      </v-expand-x-transition>
    </v-list-item>

    <v-col class="actions">

      <v-btn @click.prevent.native="toggleActions =!toggleActions" large icon color="primary">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-col>
  </v-card>
</template>

<script>
  import {mapGetters} from "vuex";
  import {deleteBrand} from "../graphql/mutations";
  import {process_api_error} from "@/utils/utils"
  import SpotS3Image from "../Pages/SpotS3Image";
  import {getBrand} from "../graphql/queries";

  export default {
    name: "BrandTile",
    components: {SpotS3Image},
    props: ["brand"],
    data: () => ({
      toggleActions: false
    }),
    computed: {
      ...mapGetters(['loadingState']),
      manager_info() {
        if (this.brand.brandmanagers.length == 0) {
          return "No Managers Defined"
        }
        if (this.brand.brandmanagers.length == 1) {
          return "1 Manager"
        } else {
          return this.brand.brandmanagers.length + " managers"
        }
      }
    },
    methods: {
      deleteBrand() {
        var that = this
        var brand_id = that.brand.id
        this.$store.dispatch('removeBrand', this.brand.id)
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(deleteBrand, {input: {id: brand_id}}))
          .then(() => {
          })
          .catch((e) => {
            this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(getBrand, {id: brand_id}))
              .then((res) => {
                this.$store.dispatch('addBrand', res.data.getBrand)
              })
            process_api_error(`Error Deleting Brand`, e)
          });
      }
    }
  }
</script>

<style lang="scss" scoped>


  .v-list-item {
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;

    .v-list-item__title {
      font-weight: 600;

    }

    .v-list-item__subtitle {
      color: #37474F !important;
    }
  }


  .brand-card {
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 8px !important;
    display: grid;
    grid-template-columns: 1fr auto;

  }
</style>



// WEBPACK FOOTER //
// src/Brands/BrandTile.vue